// Content recovered from the Internet Archive snapshot of stovescotland.co.uk (22 Jan 2025)
// Images are served from the archive's preserved copies of the original media library.

// NOTE: The original archive.org media is unreachable from the build network, so close-matching
// stove photography is used here. Original photos can be dropped in once the site is deployed.
const HERO_IMG = "https://images.unsplash.com/photo-1605357625516-575fec3e086b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const company = {
  name: "Stove Scotland",
  tagline: "Multi Fuel & Wood Burning Stoves",
  strap: "SUPPLY - INSTALL - MAINTAIN",
  phone: "01501 760051",
  phoneHref: "tel:01501760051",
  email: "info@stovescotland.co.uk",
  heroImg: HERO_IMG,
  facebook: "https://www.facebook.com/stovescotland/",
  instagram: "https://www.instagram.com/stovescotland_/",
  cards: ["Visa", "Mastercard", "Maestro", "Amex"],
};

export const nav = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#quote" },
];

export const welcome = {
  heading: "Welcome To Stove Scotland",
  intro:
    "Stove Scotland is a family-run, Father and Sons business with a burning passion for stoves!",
  body:
    "Our first priority is to provide you with a professional, honest and reliable service at an affordable price. As market experts with a comprehensive knowledge of stoves and fires, we will work with you to ensure that your stove will perfectly fit the style and dimensions of your room.",
};

const G = "https://images.unsplash.com/";
const q = "?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";
// Client's real installation photos live in /public/gallery (stove-01.jpg ...).
export const gallery = [
  { src: "/gallery/stove-01.jpg", alt: "Contemporary black stove with oak beam and slate hearth" },
  { src: "/gallery/stove-02.jpg", alt: "Wood burning stove in stone fireplace with oak mantel" },
  { src: "/gallery/stove-03.jpg", alt: "Cylindrical stove on slate hearth against split-face wall" },
  { src: "/gallery/stove-04.jpg", alt: "Multi fuel stove set into brick arch inglenook" },
  { src: "/gallery/stove-05.jpg", alt: "Corner stove with copper split-face feature wall" },
  { src: "/gallery/stove-06.jpg", alt: "Cylindrical corner stove on curved slate hearth" },
  { src: "/gallery/stove-07.jpg", alt: "Stove in limestone surround with granite hearth" },
  { src: "/gallery/stove-08.jpg", alt: "Stove with oak beam, herringbone chamber and round mirror" },
  { src: "/gallery/stove-09.jpg", alt: "Media wall stove with oak shelf and black granite hearth" },
  { src: "/gallery/stove-10.jpg", alt: "Corner cylindrical stove beside patio doors with snowy garden" },
  { src: "/gallery/stove-11.jpg", alt: "Skye 8kW multi-fuel stove - DEFRA approved" },
  { src: "/gallery/stove-12.jpg", alt: "Introducing the Skye - first of our Island Range, packages from £3,700" },
  { src: "/gallery/stove-13.jpg", alt: "Stove in slate chamber with oak beam mantel" },
  { src: "/gallery/stove-14.jpg", alt: "Cylindrical stove in lit chamber with oak beam and round mirror" },
];

export const problems = {
  heading: "Is Your Stove Suffering From",
  items: ["Down Draft", "Hard To Light", "Smoke Filled Room", "Ceiling & Walls Marked"],
  body:
    "Here at Stove Scotland we GUARANTEE that we can solve this problem or your money back. Please contact us for a free no obligation quote.",
};

export const services = [
  {
    title: "Supply & Install",
    img: `${G}photo-1579761804843-f997ade7fa35${q}`,
    body:
      "As local market leaders, we have access to every stove and flue system available. We also provide a wide range of supply and installation packages to meet your requirements and budget.",
  },
  {
    title: "Supply Only",
    img: `${G}photo-1648332202349-a1ca4f99ee0c${q}`,
    body:
      "We can supply you with anything that you might need for your fire, stove or flue. We have access to a huge range of full systems and individual components.",
  },
  {
    title: "Maintenance",
    img: `${G}photo-1603283297903-81277ca7ce8f${q}`,
    body:
      "To keep your stove in tiptop shape, some careful TLC is required. We offer a full professional maintenance and chimney sweep package so that you and your family will enjoy your stove for years to come.",
  },
];

export const spillTest = {
  heading: "Stove Spill Test Service",
  body1: "Spills Test as required by Local Authority Building control or Architects.",
  body2:
    "Spills tests are required when there is an appliance, such as: cooker hood extractor fan or electrical extractor fan in the same floor space or room as a stove.",
  body3:
    "The test is carried out to prove that fumes / smoke is not being drawn by the extractor system that could lead to carbon monoxide being present in the room.",
};

export const installers = {
  heading: "Log Burning Stove Installers in Scotland",
  img: `${G}photo-1696814543693-31fcf942ccb7${q}`,
  body1:
    "All of our staff are professional and friendly tradesmen who will treat both you and your home with the utmost respect. With a variety of packages and installation options available, we are confident that we can find the right one to suit you and your budget.",
  body2:
    "Contact us for a free, friendly, no-obligation quote and get the perfect stove for you and your family.",
  areasHeading: "Some of the areas we work in are:",
  areas: [
    "West Lothian", "Ayrshire", "Aberdeen", "Falkirk & Stirling", "Glasgow",
    "Dundee", "Fife", "Edinburgh", "Linlithgow", "Perth",
  ],
};

export const reviews = [
  { text: "So pleased with our wood burning stove, it looks fabulous and I am actually looking forward to the winter months. Thanks for an excellent service guys! I will be recommending to all.", name: "Mr. & Mrs. Banks", place: "Crookston" },
  { text: "Great service from beginning to end and a very professional job. Now I just have to wait for the cold nights to fire my stove up, for the first time in a LONG time, I\u2019m praying for a harsh winter! Already recommended to quite a few friends.", name: "Lynn Mcfarlane", place: "Rutherglen" },
  { text: "I would highly recommend Stove Scotland for your installation. The guys were on time and the work was of a very high standard. I am delighted with my Merlin stove which is the focal point of my new house. If you are considering a stove then give Charlie a call. A family company who were very reasonably priced and did a first class job.", name: "Mr O\u2019Neill", place: "Glasgow" },
  { text: "We are absolutely delighted with our new multi-fuel stove, supplied on time and fitted in a day. We were very impressed with everyone from Stove Scotland, from Charlie explaining the types of fire available to us, to the lads fitting the fire. It comfortably heats 5 rooms in our house, looks good and we've not had to put our radiators on since fitting. Thoroughly recommended.", name: "Hugh McGuigan", place: "Google" },
  { text: "Excellent service from first discussing options to installation and finally tiling. Highly recommend using Stove Scotland.", name: "E4E Edinburgh", place: "Google" },
  { text: "They did a great job putting in a stove for us. Excellent service!", name: "Paul Mahato", place: "Google" },
  { text: "Have had 2 stoves fitted by them. Very helpful and knowledgeable. They took lots of time with us and advised us what would be best in our rooms. No pressure sales. They don't have a showroom so great prices, would highly recommend them, great family run company. Can't thank them enough for all their advice and help.", name: "Rhona O", place: "Google" },
  { text: "Having given Charlie a call after speaking to many different stove companies, we knew immediately he would provide an exceptional service, from visiting us the same evening we called through to his sons that deliver and complete the installation, a truly family business.", name: "Andrew Valentini", place: "Google" },
  { text: "What a nice bunch at Stove Scotland. Great quote and friendly and fast service. Highly recommend.", name: "Alasdair Andrew", place: "Google" },
  { text: "Top class service and very helpful.", name: "Michelle Murphy", place: "Google" },
];

export const hearOptions = [
  "TV", "Radio", "Google", "Flyer", "Saw Your Van", "Word Of Mouth", "Other",
];

export const footerLinks = {
  services: [
    { label: "Supply & Install", href: "#services" },
    { label: "Supply Only", href: "#services" },
    { label: "Maintenance", href: "#services" },
    { label: "Spill Test", href: "#services" },
  ],
  help: [
    { label: "Free Quote", href: "#quote" },
    { label: "Reviews", href: "#reviews" },
    { label: "Contact Us", href: "#quote" },
  ],
  legal: [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms & Conditions", href: "/terms" },
    { label: "Cookie Policy", href: "/cookies" },
  ],
};


export const showcaseCategories = ["All", "Freestanding", "Corner", "Inset", "Traditional"];

export const showcase = [
  { src: "/gallery/stove-01.jpg", title: "Contemporary stove with oak beam", category: "Freestanding" },
  { src: "/gallery/stove-02.jpg", title: "Stone fireplace wood burner", category: "Traditional" },
  { src: "/gallery/stove-03.jpg", title: "Cylindrical stove on slate hearth", category: "Freestanding" },
  { src: "/gallery/stove-04.jpg", title: "Brick arch inglenook stove", category: "Inset" },
  { src: "/gallery/stove-05.jpg", title: "Corner stove with feature wall", category: "Corner" },
  { src: "/gallery/stove-06.jpg", title: "Corner stove on curved hearth", category: "Corner" },
  { src: "/gallery/stove-07.jpg", title: "Limestone surround stove", category: "Traditional" },
  { src: "/gallery/stove-08.jpg", title: "Oak beam & herringbone chamber", category: "Inset" },
  { src: "/gallery/stove-09.jpg", title: "Media wall stove", category: "Inset" },
  { src: "/gallery/stove-10.jpg", title: "Corner stove with garden view", category: "Corner" },
  { src: "/gallery/stove-11.jpg", title: "Skye 8kW multi-fuel stove", category: "Freestanding" },
  { src: "/gallery/stove-12.jpg", title: "Introducing the Skye - Island Range", category: "Freestanding" },
  { src: "/gallery/stove-13.jpg", title: "Slate chamber with oak beam", category: "Inset" },
  { src: "/gallery/stove-14.jpg", title: "Lit chamber with oak beam & mirror", category: "Inset" },
];

// Original archive.org photo URLs — unreachable from the build sandbox but valid once deployed.
// Flip USE_ARCHIVE_IMAGES to true after deployment to restore the client's real photos.
export const USE_ARCHIVE_IMAGES = false;
const ARCH = "https://web.archive.org/web/20250122070454im_/https://stovescotland.co.uk/wp-content/uploads";
export const archiveGallery = [
  `${ARCH}/2020/07/stove-scotland-multi-fuel-and-wood-burning-stoves-170.jpg`,
  `${ARCH}/2020/07/stove-scotland-multi-fuel-and-wood-burning-stoves-38.jpg`,
  `${ARCH}/2020/08/PHOTO-2020-08-19-14-53-03.jpg`,
  `${ARCH}/2020/08/PHOTO-2020-08-19-14-53-29.jpg`,
  `${ARCH}/2020/08/PHOTO-2020-08-19-14-53-48.jpg`,
  `${ARCH}/2020/08/PHOTO-2020-08-19-14-54-03.jpg`,
  `${ARCH}/2020/08/PHOTO-2020-08-19-14-54-19.jpg`,
  `${ARCH}/2020/08/PHOTO-2020-08-19-14-54-40.jpg`,
  `${ARCH}/2020/08/PHOTO-2020-08-19-14-54-57.jpg`,
  `${ARCH}/2020/08/PHOTO-2020-08-19-14-55-12.jpg`,
  `${ARCH}/2020/08/PHOTO-2020-08-19-14-55-32.jpg`,
];
